package horcrux.frontend.common.views.collections.editcollectionmenu

import horcrux.common.api.dtos.types.CollectionMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.HasViewName
import horcrux.frontend.common.MaybeState
import horcrux.frontend.common.views.chat.Theme
import js.objects.jso
import mui.icons.material.Edit
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.IconButtonEdge
import mui.material.MenuItem
import mui.material.Size
import mui.material.SvgIconSize
import mui.system.SxProps
import mui.system.sx
import react.FC
import react.Props
import react.dom.aria.ariaLabel
import react.dom.events.MouseEvent
import web.cssom.NumberType
import web.cssom.number
import web.dom.Element
import web.svg.SVGSVGElement

private typealias CloseMenu = () -> Unit

internal data class MenuItemData(
    val menuOption: HasViewName,
    val currentCollectionMetadataMaybe: CollectionMetadata? = null,
    val alwaysVisible: Boolean = false,
    val onClick: (CloseMenu) -> Unit
) {
    val sx: SxProps<Theme>
        get() = jso {
            this.opacity = getMenuItemOpacity()
        }

    private fun getMenuItemOpacity(): NumberType =
        if (alwaysVisible || currentCollectionMetadataMaybe != null) number(1.0) else number(0.1)
}

internal external interface EditCollectionMenuProps : Props {
    var menuItemDataList: List<MenuItemData>
    var globalAppState: GlobalAppState
}

internal val EditCollectionMenu = FC<EditCollectionMenuProps> { props ->
    var anchorElementMaybeState = MaybeState<Element?>()
    val openMenu = { event: MouseEvent<SVGSVGElement, *> ->
        anchorElementMaybeState.set(event.currentTarget)
    }
    val closeMenu = { anchorElementMaybeState.reset() }
    IconButton {
        this.size = Size.large
        this.edge = IconButtonEdge.end
        this.color = IconButtonColor.inherit
        this.ariaLabel = "menu"
        Edit {
            this.fontSize = SvgIconSize.large
            this.onClick = { openMenu(it) }
        }

        mui.material.Menu {
            this.anchorEl = anchorElementMaybeState.get()?.let { { _ -> it } }
            this.open = !anchorElementMaybeState.isReset()
            this.onClose = { closeMenu() }
            props.menuItemDataList.forEach { data ->
                MenuItem {
                    +data.menuOption.viewName
                    this.onClick = { data.onClick(closeMenu) }
                    this.sx { +data.sx }
                }
            }
        }
    }
}
